import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { RestApi } from '../../../shared/RestApi/restApi';

interface javersInfo {
  statusMessage: any,
  error: boolean,
  data: any
}
@Injectable({
  providedIn: 'root'
})
export class JaversauditservicesService {

  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private Http: HttpClient, private rest: RestApi) { }


  retrievejaversaudit(){
    return this.Http.get<javersInfo>(this.rest.RETRIEVE_JAVERS_URL, { headers: this.headers })
  }
}
